import React from 'react';
import FusionCheckbox from '@acuity-brands/fusion/components/Checkbox';
import {FusionPropTypes} from '../prop-types';

/**
 * @note Only for use inside the Form component. If you need to use
 * the Fusion Checkbox component, use it directly.
 */
export const FusionCheckboxAdapter = ({
  data,
  disabled,
  field,
  handleChange,
  name,
}) => (
  <FusionCheckbox
    checked={data || false}
    disabled={disabled}
    label={field.widget.attrs.hideLabel ? '' : field.label}
    name={name}
    onChange={handleChange}
    required={field.required && !field.widget.attrs.hideLabel}
    tooltip={field.help_text}
  />
);

FusionCheckboxAdapter.propTypes = FusionPropTypes;
